import { Dispatch, SetStateAction } from 'react';

import Container from '@ui/container/container';
import Modal from '@ui/modal/modal';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import { EColorVariablesV2 } from '@/types/theme-packs.types';

type CourseDeleteModalProps = {
  showDeleteModal: boolean;
  setShowDeleteModal: Dispatch<SetStateAction<boolean>>;
  courseName: string;
  deleteCourse: () => void;
};

const CourseDeleteModal = ({
  showDeleteModal,
  setShowDeleteModal,
  courseName,
  deleteCourse,
}: CourseDeleteModalProps) => {
  const handleClose = () => {
    setShowDeleteModal(false);
  };

  return (
    <Modal
      open={showDeleteModal}
      customSize={{
        width: '600px',
        height: 'auto',
        maxHeight: '300px',
        minHeight: '200px',
        maxWidth: 'calc(100vw - 80px)',
      }}
      contentWrapperClassName="padding-24 gap-40"
      onRequestClose={handleClose}
      renderHeaderContent={() => {
        return (
          <Container className="radius-10">
            <Text clamp={2} whiteSpace="wrap" tag="h3" color="var(--gray-100)" className="H3 margin-b-8">
              Delete {courseName}
            </Text>
          </Container>
        );
      }}
      renderFooterContent={() => {
        return (
          <Container borderRadius="0 0 12px 12px" className="flex fd-row jc-flex-end ai-center">
            <button className="L1 padding-v-8 padding-h-16 margin-r-8" onClick={handleClose}>
              Cancel
            </button>
            <Button
              width="105px"
              className="padding-v-8 padding-h-16"
              onClick={deleteCourse}
              backgroundColor={getThemeColorCSSVariable()}
            >
              <Text
                className="L1"
                color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
              >
                Delete
              </Text>
            </Button>
          </Container>
        );
      }}
    >
      <Container className="overflow-auto" height="100%">
        <Text tag="p" color="var(--gray-300)" className="P1">
          Are you sure you want to delete this course?
        </Text>
      </Container>
    </Modal>
  );
};

export default CourseDeleteModal;
